import { Failure, Ok } from "@megarax/fp";

import { UserTransaction } from "../store";

interface CommandProps {
  transaction: UserTransaction;
}

export const DeleteUserCommand = ({ transaction }: CommandProps) => (userId: number) =>
  transaction(async (retrieve, persist) => {
    const user = await retrieve(userId);
    if (user.isDeleted) return Failure("UserAlreadyDeleted");

    await persist({
      ...user,
      isDeleted: true,
    });

    return Ok();
  });
